/** @format */

/* eslint-disable import/no-unused-modules */
import moment from 'moment';

export const DEFAULT_DURATION = 1;

export const DEFAULT_PRICE_MIN = 100;
export const DEFAULT_PRICE_MAX = 1500;
export const DEFAULT_DISTANCE = 30000;
export const DATE_MINIMUM = moment();
export const DEFAULT_ORDER_BY = 'availability_asc';
export const DEFAULT_CHECK_IN_DATE = moment().toJSON();
// export const DEFAULT_CHECK_OUT_DATE = moment().add(3, 'days').toJSON();
export const NAME_DISTANCE_FROM_ADDRESS = 3000;

export const DEFAULT_FILTERS = {
  colivers: { min: 1 },
  singleRoom: true,
  colivingBuilding: true,
  entireStudio: true,
  monthlyPrice: {
    min: 100,
    max: 1500,
  },
  duration: 12,
  freeParking: false,
  checkInDate: DEFAULT_CHECK_IN_DATE,
  carParking: false,
  bikeParking: false,
  airConditioning: false,
  elevator: false,
  inSuiteLaundry: false,
  topFloor: false,
  lowerFloor: false,
  clothesDryer: false,
  parquet: false,
  internalSide: false,
  isAccessible: false,
  television: false,
  balcony: false,
  privateBathroom: false,
  concierge: false,
  gym: false,
  coworkingSpaces: false,
  bar: false,
};
export const DEFAULT_FILTERS_INITIAL_STATE = (cityName: string) => {
  return {
    area: {},
    checkInDate: DEFAULT_CHECK_IN_DATE,
    singleRoom: true,
    entireStudio: true,
    sharedApartment: true,
    colivingBuilding: true,
    orderBy: DEFAULT_ORDER_BY,
    monthlyPrice: {
      min: 100,
      max: 1500,
    },
    cityName: cityName,
    concierge: false,
    elevator: false,
    privateBathroom: false,
    balcony: false,
    bikeParking: false,
    topFloor: false,
    lowerFloor: false,
    parquet: false,
    clothesDryer: false,
    airConditioning: false,
    internalSide: false,
    gym: false,
    inSuiteLaundry: false,
  };
};
export const DEFAULT_FILTERS_INITIAL_STATE_FOR_POI = (cityName: string) => {
  return {
    checkInDate: DEFAULT_CHECK_IN_DATE,
    singleRoom: true,
    entireStudio: true,
    sharedApartment: true,
    colivingBuilding: true,
    orderBy: DEFAULT_ORDER_BY,
    monthlyPrice: {
      min: 100,
      max: 1500,
    },
    cityName: cityName,
    concierge: false,
    elevator: false,
    privateBathroom: false,
    balcony: false,
    bikeParking: false,
    topFloor: false,
    lowerFloor: false,
    parquet: false,
    clothesDryer: false,
    airConditioning: false,
    internalSide: false,
    gym: false,
    inSuiteLaundry: false,
  };
};
